// cart-enforcer.js (Optimized)
document.addEventListener("DOMContentLoaded", () => {
    // Only run enforcement logic if we are on the cart page
    if (!window.location.pathname.includes('/cart')) return;

    const freeGiftId = localStorage.getItem('spinWheelFreeGiftId');
    if (!freeGiftId) return;

    const enforceCartState = async () => {
        try {
            const res = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            const cart = await res.json();
            
            const hasOnlyFreeGift = cart.item_count > 0 && cart.items.every(item => item.variant_id.toString() === freeGiftId.toString());
            
            // Toggle checkout buttons
            const checkoutButtons = document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], .checkout-btn');
            checkoutButtons.forEach(btn => {
                if (hasOnlyFreeGift) {
                    btn.disabled = true;
                    btn.style.opacity = '0.5';
                    btn.style.pointerEvents = 'none';
                    if (btn.tagName === 'BUTTON') btn.innerText = "Add Paid Item to Checkout";
                    if (btn.tagName === 'INPUT') btn.value = "Add Paid Item to Checkout";
                } else {
                    btn.disabled = false;
                    btn.style.opacity = '1';
                    btn.style.pointerEvents = 'auto';
                    if (btn.dataset.originalText) {
                        if (btn.tagName === 'BUTTON') btn.innerText = btn.dataset.originalText;
                        if (btn.tagName === 'INPUT') btn.value = btn.dataset.originalText;
                    }
                }
            });

            // Lock free gift quantity rows safely inside the cart table/drawer only
            const cartRows = document.querySelectorAll('.cart-item, .cart__row, tr');
            cartRows.forEach(row => {
                const rowHtml = row.innerHTML.toLowerCase();
                if (rowHtml.includes(freeGiftId.toString()) || rowHtml.includes('gift-')) {
                    const qtyInput = row.querySelector('input[name*="updates"], input[name*="quantity"]');
                    if (qtyInput) {
                        qtyInput.readOnly = true;
                        qtyInput.value = 1;
                    }
                    const controls = row.querySelectorAll('button, a, .qty-btn, .quantity__button');
                    controls.forEach(ctrl => {
                        const txt = (ctrl.innerText || '').trim();
                        if (txt === '+' || txt === '-' || txt === '−' || ctrl.classList.contains('quantity__button')) {
                            ctrl.style.display = 'none';
                        }
                    });
                }
            });
        } catch (err) {
            console.error("Cart enforcer check failed:", err);
        }
    };

    enforceCartState();

    // Listen to Shopify's standard AJAX cart update events instead of a 1-second interval timer
    document.addEventListener('cart:updated', enforceCartState);
    document.addEventListener('ajaxCart.afterCartLoad', enforceCartState);
});